// extracted by mini-css-extract-plugin
module.exports = {"banner":"B7HWt","dots":"_1wJXx","content":"_3Tnd0","image":"_2jCoc","picture":"_3uE8N","caption":"_3i-WI"};